import { useNavigate } from 'react-router-dom';
import { Heart } from 'lucide-react';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="app-container min-h-screen flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-white font-bold text-8xl mb-4">404</h1>
        <p className="text-gray-400 text-2xl mb-8">Page not found</p>
        <button
          onClick={() => navigate('/')}
          className="px-8 h-12 bg-accent text-background font-semibold rounded-full transition-all duration-300 active:scale-95 inline-flex items-center gap-2"
        >
          <Heart className="fill-current" size={20} />
          Go Home
        </button>
      </div>
    </div>
  );
}
